import React, { useEffect } from 'react'
import { useStoreState, useStoreActions } from 'easy-peasy'

export default function InputHidden({ name }) {
  const [input, locale] = useStoreState(state => [
    state.form.getByName(name),
    state.locale.locale,
  ])
  const [setInputValue] = useStoreActions(actions => [
    actions.form.setInputValue,
  ])

  useEffect(() => {
    setInputValue({ name, value: locale })
  }, [name, setInputValue, locale])

  return (
    <input
      type="hidden"
      id={`hidden-${name}`}
      name={name}
      value={locale}
    />
  )
}
